import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DurationComponent } from '@app/blocks/ui/controls/duration/duration.component';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-duration',
    imports: [
        CommonModule,
        FormlyModule,
        ReactiveFormsModule,
        DurationComponent
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
        <div [formGroup]="form" [id]="field.key" [class]="'form-group schema-form-duration has-feedback ' + props['htmlClass']"
        [class.has-success]="(formControl.touched || formControl.dirty) && formControl.status === 'VALID'"
        [class.has-error]="(formControl.touched || formControl.dirty) && formControl.status === 'INVALID'">
            <label class="control-label" [for]="field.key">{{props['title']}}</label>
            <p *ngIf="props['description']">{{props['description']}}</p>
            <div class="has-feedback">
                <app-duration
                    [props]="props"
                    [name]="field.key!.toString()"
                    [id]="field.key!.toString()"
                    [formControl]="formControl"
                    [aria-describedby]="field.key!.toString() + 'Status'"
                    yearOrder="desc" startYear="1980" endYear="2000"
                    >
                </app-duration>
                <ng-container *ngIf="(formControl.touched || formControl.dirty) && formControl.errors === null">
                    <i class="fa fa-check-circle-o form-control-feedback" aria-hidden="true"></i>
                </ng-container>
                <ng-container *ngIf="(formControl.touched || formControl.dirty) && formControl.errors">
                    <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                </ng-container>
            </div>
            <ng-container *ngIf="(formControl.touched || formControl.dirty) && formControl.errors">
                    <div *ngIf="formControl.hasError('required')">Required</div>
                        <!-- <div *ngIf="error === 'required' || error === 'monthRequired' || error === 'yearRequired'">Required</div> -->
            </ng-container>
        </div>
  `
})
export class DurationFieldTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
    ngOnInit(): void {
        if (this.formControl.value) {
            this.formControl.markAsTouched();
        }
    }
}
